module.exports = __webpack_public_path__ + "img/bt.3b610a2f.svg";